'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FEATURE_USE = 'featureUse';
var LIFECYCLE = 'lifeCycle';
var INFO = 'info';
var SYSTEM = 'system';
var API_USE = 'apiUse';

/**
 * Enum containing all types of Message Bus Events to be set on MessageBusEvent object.
 */

var MessageBusEventType = function () {
    function MessageBusEventType() {
        _classCallCheck(this, MessageBusEventType);
    }

    _createClass(MessageBusEventType, null, [{
        key: 'values',
        value: function values() {
            return [FEATURE_USE, LIFECYCLE, INFO, SYSTEM, API_USE];
        }
    }, {
        key: 'FEATURE_USE',
        get: function get() {
            return FEATURE_USE;
        }
    }, {
        key: 'LIFECYCLE',
        get: function get() {
            return LIFECYCLE;
        }
    }, {
        key: 'INFO',
        get: function get() {
            return INFO;
        }
    }, {
        key: 'SYSTEM',
        get: function get() {
            return SYSTEM;
        }
    }, {
        key: 'API_USE',
        get: function get() {
            return API_USE;
        }
    }]);

    return MessageBusEventType;
}();

exports.default = MessageBusEventType;